<template>
  <button class="skip">
    <FowardIcon v-if="props.isFoward"/>
    <RewindIcon v-else />
  </button>
</template>

<script setup>
  import { Props } from './props';
  //-------------------------------------
  import FowardIcon from '../../svg/FowardIcon.vue';
  import RewindIcon from '../../svg/RewindIcon.vue';
  //-------------------------------------
  const props = defineProps(Props());
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>